export const PricingTypes = Object.freeze({
  TOTAL_TIER: 'TOTAL_TIER',
  PER_UNIT_TIER: 'PER_UNIT_TIER'
});
export const getTierDescription = (priceType, unitCount, prevUnitCount = 0) => {
  if (unitCount === -1 && prevUnitCount === 5000) {
    return 'Unlimited users';
  } else if (unitCount === -1) {
    // In case of 20k , last 2 tier difference is 5k, it will be same for further new upcoming tiers ( 25k, 30k , 35k , 40k , 45k and 50k ).
    // Instead of showing unlimited, last tier should be 15001 to 20000 users
    return "".concat(prevUnitCount + 1, " - ").concat(prevUnitCount + 5000, " users");
  }

  if (priceType === PricingTypes.TOTAL_TIER) {
    return "".concat(unitCount, " users");
  }

  return "".concat(prevUnitCount + 1, " - ").concat(unitCount, " users");
};

const getFlattenedAppPrice = appsPricing => appsPricing.map(pricing => {
  const priceType = pricing.perUnitItems ? PricingTypes.PER_UNIT_TIER : PricingTypes.TOTAL_TIER;
  const priceItems = pricing.perUnitItems || pricing.items;
  const flattenAppsPricing = priceItems.map((item, index) => getAppData(priceType, item, index === 0 ? 0 : priceItems[index - 1].unitCount));

  if (priceType === PricingTypes.PER_UNIT_TIER) {
    flattenAppsPricing.unshift(getAppData(PricingTypes.TOTAL_TIER, pricing.items[0]));
  }

  function getAppData(PricingType, item, prevUnitCount) {
    return {
      priceType: PricingType,
      unitCount: item.unitCount,
      amount: item.localCurrencyAmount,
      description: getTierDescription(PricingType, item.unitCount, prevUnitCount),
      localCurrency: item.localCurrency
    };
  }

  return flattenAppsPricing;
});

const getAppsTotalPricing = flattenAppPrice => flattenAppPrice.reduce((accumulatedPrice, currentPrice) => accumulatedPrice.map((price, index) => ({ ...price,
  amount: price.amount + currentPrice[index].amount
})));

export const applyFlatDiscount = (appsTotalPrice, flatDiscount) => {
  let previousMaxTierPrice;
  let previousUnitCount; // in case of 10k or 20k , last 2 tier difference is 5k, it will be same for further new tiers whenever added

  const lastTwoTierDifference = 5000;
  return appsTotalPrice.map(priceItem => {
    let maxTieredAmount = priceItem.amount;

    if (priceItem.priceType === PricingTypes.PER_UNIT_TIER) {
      const currentUnitCount = priceItem.unitCount === -1 ? lastTwoTierDifference + previousUnitCount : priceItem.unitCount;

      if (previousUnitCount && previousMaxTierPrice) {
        maxTieredAmount = previousMaxTierPrice + (currentUnitCount - previousUnitCount) * priceItem.amount;
      } else {
        maxTieredAmount = currentUnitCount * priceItem.amount;
      }

      previousUnitCount = priceItem.unitCount;
    }

    previousMaxTierPrice = maxTieredAmount;
    const discountAmount = maxTieredAmount * flatDiscount / 100;
    return { ...priceItem,
      discountPercentage: flatDiscount,
      discountAmount,
      totalAmount: maxTieredAmount - discountAmount
    };
  });
};
export const getAppsPricingWithDiscount = (appsPricing, flatDiscount) => {
  const flattenAppPrice = getFlattenedAppPrice(appsPricing);
  const appsTotalPrice = getAppsTotalPricing(flattenAppPrice);
  return applyFlatDiscount(appsTotalPrice, flatDiscount);
};